module.exports = __webpack_public_path__ + "img/青叶胆.e8c958e2.jpg";